import { ComponentType, useMemo } from 'react';
import { SvgIconProps } from '@mui/material';
import Stack from '@mui/material/Stack';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';

import { useDictionary } from '@cvt/hooks/useDictionary';
import { Dictionary } from '@shared/dictionary';

import { Section } from '../components/Section/Section';


export const StepsOverview = () => {
  const dictionary = useDictionary();
  const steps = useMemo(() => getSteps(dictionary), [dictionary]);

  return (
    <Stack gap={2}>
      {steps.map(({ title, subtitle, icon }, index) => (
        <Section
          key={index}
          helperText={`Step ${index + 1}`}
          title={title}
          subtitle={subtitle}
          icon={icon}
        />
      ))}
    </Stack>
  );
};

type Step = {
  title: string
  subtitle: string
  icon: ComponentType<SvgIconProps>
}

const getSteps = (dictionary: Dictionary): Step[] => {
  return Array.from<Step>({ length: 5 }).map((_, index) => {
    const key = (index + 1) as keyof typeof dictionary.start.steps;

    return {
      ...dictionary.start.steps[key],
      icon: stepIconMap[key],
    };
  });
};

const stepIconMap: Record<number, ComponentType<SvgIconProps>> = {
  1: PersonAddAltOutlinedIcon,
  2: PhotoCameraOutlinedIcon,
  3: FavoriteBorderOutlinedIcon,
  4: SendOutlinedIcon,
  5: PeopleOutlineOutlinedIcon,
};
